
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/45d0854881d907e8cddfcd7aa22fcf03.png"
              alt="Fun Time Photobooths"
              className="h-16 w-auto"
            />
          </Link>
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="/overhead-360"
              className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Overhead 360
            </Link>
            <Link
              to="/photo-booth"
              className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Photo Booth
            </Link>
            <Link
              to="/contact"
              className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              About
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
